import React from "react";
import {useEffect} from "react";
import {useJoyride} from "react-joyride";
import {useTranslation} from "../../../hooks/useTranslation";

const JoyrideTour = ({steps = [], startTour, setStartTour}) => {
    const {t} = useTranslation();
    const { controls, Tour } = useJoyride({
        continuous: true,
        debug: false,
        initialStepIndex: 0,
        options: {
            skipScroll: true,
        },
        onEvent: (ev) => {
            if (ev.action === "close") controls.skip();
        },
        steps: steps.map((o) => {
            return {
                ...o,
                skipBeacon: true,
                disableBeacon: true,
            }
        }),
        styles: {
            buttonBack: {
                color: '#76AEB7',
            },
            buttonPrimary: {
                backgroundColor: '#76AEB7'
            }
        },
        locale: {
            back: t("SettingsImportExport.joyride.back"),
            close: t("SettingsImportExport.joyride.close"),
            last: t("SettingsImportExport.joyride.last"),
            next: t("SettingsImportExport.joyride.next"),
            open: t("SettingsImportExport.joyride.open"),
            skip: t("SettingsImportExport.joyride.skip")
        },
    });

    useEffect(() => {
        if (startTour) {
            setStartTour(false);
            controls.start();
        }
    }, [startTour])

    return (
        <React.Fragment>
            {Tour}
        </React.Fragment>
    )
}

export default JoyrideTour;
